import React from "react";
import { Modal } from "react-bootstrap";

const ENGModalBody = ({ contents }: { contents: any }) => {
  return <Modal.Body style={styles.p0}>{contents}</Modal.Body>;
};

const styles = {
  p0: { padding: "0px", margin: "0px" },
};

export default ENGModalBody;
